<ng-container *transloco="let t; prefix: 'alert'">
  @if (viewStyle() === "small") {
    <div
      class="t-flex t-items-center t-gap-2 t-px-3 t-py-2 t-rounded-lg t-border t-transition-all hover:t-shadow-md t-cursor-pointer"
      [class]="
        getAlertBgColor(alert().priority, alert().alertStatus) +
        ' ' +
        getAlertBorderColor(alert().priority, alert().alertStatus)
      "
      (click)="toggleExpanded($event)"
    >
      <i
        class="[class] + ' t-text-lg'"
        [ngClass]="getAlertIcon(alert().alertType)"
        [class]="getAlertIconColor(alert().priority, alert().alertStatus)"
      ></i>

      <div class="t-flex-1 t-min-w-0">
        <p
          class="t-text-sm t-font-medium"
          [class]="
            getAlertTextColor(alert().priority, alert().alertStatus) +
            (isExpanded() ? '' : ' t-truncate')
          "
        >
          {{ alert().message }}
        </p>
      </div>

      @if (alert().alertStatus === AlertStatus.ACTIVE) {
        <button
          type="button"
          [disabled]="isDismissing"
          (click)="$event.stopPropagation(); dismiss()"
          class="t-p-1 t-rounded-md hover:t-bg-black/5 focus:t-outline-none focus:t-ring-2 focus:t-ring-black/10 t-transition-colors t-border-0 t-bg-transparent"
          [class]="getAlertTextColor(alert().priority, alert().alertStatus)"
          [attr.aria-label]="t('dismissAlert')"
        >
          @if (isDismissing) {
            <i class="pi pi-spin pi-spinner t-text-sm"></i>
          } @else {
            <i class="pi pi-times t-text-sm"></i>
          }
        </button>
      }
    </div>
  } @else {
    <div
      class="t-flex t-items-start t-gap-3 t-p-3 t-rounded-lg t-border t-transition-all hover:t-shadow-sm"
      [class]="
        getAlertBgColor(alert().priority, alert().alertStatus) +
        ' ' +
        getAlertBorderColor(alert().priority, alert().alertStatus) +
        ' '
      "
      [ngClass]="{
        't-opacity-70': alert().alertStatus === AlertStatus.DISMISSED,
      }"
    >
      <div
        class="t-flex-shrink-0 t-flex t-items-center t-justify-center t-rounded-full t-h-8 t-w-5"
        [class]="getAlertBgColor(alert().priority, alert().alertStatus)"
      >
        <i
          class="t-text-base"
          [ngClass]="getAlertIcon(alert().alertType)"
          [class]="getAlertIconColor(alert().priority, alert().alertStatus)"
        ></i>
      </div>

      <div class="t-flex-1 t-min-w-0">
        <div
          class="t-text-sm t-font-semibold"
          [class]="getAlertTextColor(alert().priority, alert().alertStatus)"
        >
          {{ alert().projectName }}
        </div>

        <div
          class="t-text-sm t-leading-relaxed"
          [class]="
            getAlertTextColor(alert().priority, alert().alertStatus) +
            ' t-opacity-90'
          "
        >
          {{ alert().message }}
        </div>

        <div
          class="t-text-xs t-mt-1"
          [class]="
            getAlertTextColor(alert().priority, alert().alertStatus) +
            ' t-opacity-70'
          "
        >
          {{ alert().createdAt | date: "mediumDate" }}
        </div>
      </div>

      @if (alert().alertStatus === AlertStatus.ACTIVE) {
        <button
          type="button"
          [disabled]="isDismissing"
          (click)="dismiss()"
          class="t-flex-shrink-0 t-p-1.5 t-rounded-md hover:t-bg-black/5 focus:t-outline-none focus:t-ring-2 focus:t-ring-black/10 t-transition-colors t-border-0 t-bg-transparent"
          [class]="getAlertTextColor(alert().priority, alert().alertStatus)"
          [attr.aria-label]="t('dismissAlert')"
        >
          @if (isDismissing) {
            <i class="pi pi-spin pi-spinner t-text-base"></i>
          } @else {
            <i class="pi pi-times t-text-base"></i>
          }
        </button>
      }
    </div>
  }
</ng-container>
